export default "__VITE_ASSET__C5PovQAS__ 500w";